import { render } from "./DecisionCards.vue?vue&type=template&id=546121ef&scoped=true"
import script from "./DecisionCards.vue?vue&type=script&lang=js"
export * from "./DecisionCards.vue?vue&type=script&lang=js"

import "./DecisionCards.vue?vue&type=style&index=0&id=546121ef&scoped=true&lang=css"

import exportComponent from "/var/www/EasternFront_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-546121ef"]])

export default __exports__